<template>
  <div>
    <section
      v-if="allowSearchInquiry || allowSearchInstant"
      class="search-wrapper"
    >
      <div
        class="jumbotron jumbo-bg"
        :style="[
          bannerImage
            ? {
                background: `#f4f4f9 url(${bannerImage}) no-repeat right center`,
                'background-size': 'contain',
              }
            : {},
        ]"
      >
        <div class="row text-center">
          <!-- <div class="search-mode-box" v-if="isSearchModeVisible">
            <div class="search-mode">
              <label class="ncheck">
                <input type="checkbox" v-model="isInquiry" />
                <span class="checkmark"></span>
                {{ searchModeText }}
              </label>
              <div class="search-mode-info">{{ searchModeDescription }}</div>
            </div>
            <div class="polygon-rad"></div>
          </div> -->
          <div class="option-group">
            <div class="option-container">
              <input
                value="airport-transfer"
                v-model="mode"
                class="option-input"
                id="search-mode-inquiry"
                type="radio"
                name="searchModeOptions"
              />
              <input
                value="rental"
                v-model="mode"
                class="option-input"
                id="search-mode-ondemand"
                type="radio"
                name="searchModeOptions"
              />
              <!-- <input
                value="multi-trip"
                v-model="mode"
                class="option-input"
                id="search-mode-multi"
                type="radio"
                name="searchModeOptions"
              /> -->
              <!-- id="search-mode-hybrid" -->

              <label class="option" for="search-mode-inquiry">
                <span class="option__indicator"></span>
                <span class="option__label"
                  >Transfer
                  <!-- Airport Transfer<sub>mode</sub> -->
                </span>
              </label>

              <label class="option" for="search-mode-ondemand">
                <span class="option__indicator"></span>
                <span class="option__label">Hourly</span>
                <!-- <span class="option__label"> Rental<sub>mode</sub> </span> -->
              </label>
              <!-- <label class="option" for="search-mode-multi">
                <span class="option__indicator"></span>
                <span class="option__label">Multi</span>
              </label> -->
            </div>
          </div>
        </div>
      </div>
      <div class="main__search">
        <div class="tab-content">
          <!-- <div class="row cRow hidden">
            <div class="col-sm-8">
              <div id="customerType" class="btn btn-option option--white">
                <span>Corporate Name</span>
                <div class="menuItem menuItem-left">
                  <ul class="trip-type">
                    <li>
                      <div>Yamaha Music Distributor Indonesia, PT</div>
                    </li>
                    <li class="active">
                      <div>Astra International Motor, PT</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="corporate__name">Telkom Indonesia, PT</div>
            </div>
          </div> -->

          <rentalSearchForm
            :mode="mode"
            :companies="companies"
            :services="permissions"
          />
          <airportTransferSearchForm
            :mode="mode"
            :companies="companies"
            :services="permissions"
          />
          <multiTripForm :mode="mode" />
        </div>
      </div>
    </section>
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6"></div>
          <div class="col-sm-6 text-right"></div>
        </div>
      </div>
    </section>
    <div class="content-wrapper hidden"></div>
  </div>
</template>

<script>
import rentalSearchForm from "@/components/availability/form/Rental";
import multiTripForm from "@/components/availability/form/MultiTrip";
import airportTransferSearchForm from "@/components/availability/form/Transfer";
import maverickAutoComplete from "@/plugins/google/autocomplete.js";
import companyService from "@/services/master/company/companyService.js";
import { UserType } from "@/models/constants";

export default {
  components: {
    rentalSearchForm,
    airportTransferSearchForm,
    multiTripForm,
  },
  data() {
    return {
      isSearchModeVisible: false,
      bannerImage: null,
      autocomplete: null,
      mode: "airport-transfer",
      permissions: {},
      companies: [],
      UserType: UserType,
      profile: null,
    };
  },
  computed: {
    allowSearchInquiry() {
      if (this.permissions["InquiryAvailability"]) {
        return ["SearchAirport", "SearchRental"].some((service) =>
          this.permissions["InquiryAvailability"].includes(service)
        );
      } else {
        return false;
      }
    },
    allowSearchInstant() {
      if (this.permissions["InstantAvailability"]) {
        return ["SearchAirport", "SearchRental"].some((service) =>
          this.permissions["InstantAvailability"].includes(service)
        );
      } else {
        return false;
      }
    },
    searchModeText() {
      return this.isInquiry ? "Inquiry Search" : "Instant Search";
    },
    searchModeDescription() {
      return this.isInquiry
        ? "Unchecked for instant search"
        : "Checked for inquiry search";
    },
    // isInquiry() {
    //   return this.mode === "Inquiry";
    // },
  },
  async created() {
    await this.$store.dispatch("setting/removeSetting");
    await Promise.all([this.initUserPermissions(), this.initGLobalSettings()]);
    await this.getAllCompanies();

    this.$helper.scrollTop();

    // document.querySelectorAll(".product-header").forEach((element) => element.classList.remove("active"));
    // document.querySelector(".product-header").classList.add("active");
    this.$helper.collapseMenu();
    this.$helper.setNavigationClass();
  },
  mounted() {
    // creates map instance
    this.autocomplete = new maverickAutoComplete();
  },
  methods: {
    async getAllCompanies() {
      if (this.companies.length === 0) {
        this.companies = await companyService.getAllActive();
      }
    },
    async initUserPermissions() {
      const profile = await this.$store.dispatch("user/getProfile");
      this.profile = profile;
      this.permissions = profile.services;
    },
    async initGLobalSettings() {
      const publicSettings = await this.$store.dispatch("setting/getAllPublic");

      // this.mode = this.$helper.extractSetting(
      //   publicSettings,
      //   "SearchMode",
      //   "Inquiry"
      // );
      // this.mode = 'Hybrid';
      this.isSearchModeVisible = this.$helper.extractSetting(
        publicSettings,
        "SearchCollection",
        false
      );
      this.bannerImage = this.$helper.extractSetting(
        publicSettings,
        "HomeBanner",
        null
      );
    },
  },
};
</script>

<style scoped>
.option-group {
  background: #fff;
  width: 90%;
  max-width: 400px;
  height: 50px;
  position: relative;
  overflow: hidden;
  border-radius: 0.25em;
  font-size: 12px;
  margin: 0.2em auto;
  transform: translateZ(0);
  top: -55px;
}
.option-container {
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 120%;
  height: 100%;
  margin: 0 -10%;
}
.option {
  overflow: hidden;
  flex: 1;
  display: block;
  padding: 0.5em;
  background: #fff;
  position: relative;
  margin: 0em;
  margin-right: 0.2em;
  border-radius: 0.25em;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-direction: column;
  cursor: pointer;
  opacity: 0.5;
  /* transition-duration: 0.8s, 0.6s; */
  transition-duration: 0.4s, 0.2s;
  transition-property: transform, opacity;
  transition-timing-function: cubic-bezier(0.98, 0, 0.22, 0.98), linear;
  will-change: transform, opacity;
}
.option:last-child {
  margin-right: 0;
}
.option__indicator {
  display: block;
  transform-origin: left bottom;
  transition: inherit;
  will-change: transform;
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  left: 0.5em;
}
/* .option__indicator:before,
.option__indicator:after {
  content: '';
  display: block;
  border: solid 2px #FFB733;
  border-radius: 50%;
  width: 0.25em;
  height: 0.25em;
  position: absolute;
  top: 0;
  right: 0;
}
 .option__indicator:after {
  background: #FFB733;
  transform: scale(0);
  transition: inherit;
  will-change: transform;
} */
.option-input {
  position: absolute;
  top: 0;
  z-index: -1;
  visibility: hidden;
}
.option__label {
  display: block;
  width: 100%;
  font-size: 1.5em;
  font-weight: bold;
  transform-origin: left bottom;
  transform: translateX(20%) scale(0.7);
  transition: inherit;
  will-change: transform;
}
.option__label sub {
  margin-left: 0.25em;
  /* font-size: 0.4em; */
  font-size: 9px;
  display: inline-block;
  /* vertical-align: 0.3em; */
  vertical-align: 10px;
}
.option__label:after {
  content: "";
  display: block;
  border: solid 2px #4fb848;
  width: 100%;
  transform-origin: 0 0;
  transform: scaleX(0.2);
  transition: inherit;
  will-change: transform;
}
.option:last-child .option__label {
  transform: translateX(0%) scale(0.7);
}
.option:last-child .option__indicator {
  transform: translateX(-20%);
}
.option-input:checked ~ .option {
  transform: translateX(-20%) translateX(0.2em);
}
.option-input:checked ~ .option .option__indicator {
  transform: translateX(0%);
}
.option-input:checked ~ .option .option__label {
  transform: translateX(40%) scale(0.7);
}
.option-input:first-child:checked ~ .option {
  transform: translateX(20%) translateX(-0.2em);
}
.option-input:first-child:checked ~ .option .option__indicator {
  transform: translateX(-40%);
}
.option-input:first-child:checked ~ .option .option__label {
  transform: translateX(0%) scale(0.7);
}
.option-input:nth-child(1):checked ~ .option:nth-of-type(1),
.option-input:nth-child(2):checked ~ .option:nth-of-type(2),
.option-input:nth-child(3):checked ~ .option:nth-of-type(3) {
  opacity: 1;
}
.option-input:nth-child(1):checked ~ .option:nth-of-type(1) .option__indicator,
.option-input:nth-child(2):checked ~ .option:nth-of-type(2) .option__indicator,
.option-input:nth-child(3):checked ~ .option:nth-of-type(3) .option__indicator {
  transform: translateX(0);
}
.option-input:nth-child(1):checked
  ~ .option:nth-of-type(1)
  .option__indicator::after,
.option-input:nth-child(2):checked
  ~ .option:nth-of-type(2)
  .option__indicator::after,
.option-input:nth-child(3):checked
  ~ .option:nth-of-type(3)
  .option__indicator::after {
  transform: scale(1);
}
.option-input:nth-child(1):checked ~ .option:nth-of-type(1) .option__label,
.option-input:nth-child(2):checked ~ .option:nth-of-type(2) .option__label,
.option-input:nth-child(3):checked ~ .option:nth-of-type(3) .option__label,
.option-input:nth-child(1):checked
  ~ .option:nth-of-type(1)
  .option__label::after,
.option-input:nth-child(2):checked
  ~ .option:nth-of-type(2)
  .option__label::after,
.option-input:nth-child(3):checked
  ~ .option:nth-of-type(3)
  .option__label::after {
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/availability/Home.vue